/**
 * Escolha de quais datas sondar em busca de um horário livre.
 *
 * Mantido puro (sem fetch) de propósito: `useAvailability.ts` é difícil de
 * testar de forma confiável (depende de `new Date()` e de várias chamadas de
 * API encadeadas). A regra de "quais datas tentar, em que ordem" mora aqui e
 * é coberta por `scheduleSuggestion.test.ts`.
 */

/**
 * Datas candidatas a sondar, a partir da data atual, em ordem cronológica.
 *
 * Quando a data atual está na lista de datas abertas, começa na próxima
 * (nunca sonda uma data anterior ou a própria data atual — ela já foi
 * checada). Quando não está (ex.: data fora do intervalo aberto), sonda a
 * lista inteira a partir do começo.
 */
export function getScheduleSuggestionCandidates(
  currentDate: string,
  availableDates: string[],
  maxCandidates: number
): string[] {
  if (!Array.isArray(availableDates) || availableDates.length === 0) return [];

  const currentIndex = availableDates.indexOf(currentDate);
  const pool =
    currentIndex === -1 ? availableDates : availableDates.slice(currentIndex + 1);

  return pool.slice(0, Math.max(0, maxCandidates));
}
